import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom'
import * as actions from '../../../reducers/form';
import { journalCategoriesAddOne } from '../../../api/list'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'

const formName = 'JournalCategoriesAdd'
export default function JournalCategoriesAdd() {
  const dispatch = useDispatch()
  const history = useHistory()
  useEffect(() => {
    dispatch(actions.formInitialize({ code: '', name: '', errorValidate: { code: false, name: false } }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const arrProps = [
    {
      field: 'code', label: 'Код', type: 'text', textProps: { inputProps: { maxLength: 20 } },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    },
    {
      field: 'name', label: 'Наименование', type: 'text', textProps: { inputProps: { maxLength: 150 } },
      validator: [value => value !== ''], errorText: 'Поле обязательно',
    }
  ]
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: { name: values.name, code: values.code },
      url: journalCategoriesAddOne.path,
      method: journalCategoriesAddOne.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd formName={formName} arr={arrProps} title='Добавить категорию журнала' />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
